    
    // matches the current value against the list of values, returns back the string for it

    export function matchValue(current, values, strings) {
      for (var i=0; i < values.length; i++) {
        if (current == values[i]) {
          return (strings[i])
        }
      }
      return ("Not Found")
    }
    
    // builds list of unique words across the list of choices
    export function buildWordListFromChoiceList(choices) {
       
      //console.log("**** build word",choices)

      // build one wordlist across all choices
      // start with these standard items

      var wordDictionary = new Object()
      wordDictionary["command"] = "a"
      wordDictionary["explain"] = "a"
      wordDictionary["done"] = "a"
      wordDictionary["scroll"] = "a"
      wordDictionary["up"] = "a"
      wordDictionary["down"] = "a"
      wordDictionary["mute"] = "a"
      wordDictionary["listen"] = "a"
      
      // build one list of all the words in all the choices
      for (var i=0; i < choices.length; i++) {
        const oneChoice = choices[i]
        const oneChoiceWordList = oneChoice.split(" ")
        for (var j=0; j < oneChoiceWordList.length; j++)
          wordDictionary[oneChoiceWordList[j]] = "a"
      }
      
      const uniqueWords = Object.keys(wordDictionary).join(" ")
      //console.log("****** UNIQUE WORDS",uniqueWords)
      return uniqueWords
  }

  // returns index of best match of the words said against choice list
  export function findBestChoiceMatch(wordsSaid, choices) {

    //console.log("in find best",wordsSaid, choices)
    var bestMatch = -1
    var bestMatchCount = -1
    
    var wordDictionary = new Object()

    for (var i=0; i < wordsSaid.length; i++) {
        const word = wordsSaid[i]
        if (wordDictionary[word] == undefined)
            wordDictionary[word] = 1
        else
            wordDictionary[word]++
    }
    
    //console.log("words said",wordDictionary)
    // if the first word is command, skip it
    const firstWord = wordsSaid[0] == "command" && wordsSaid.length > 1 ? wordsSaid[1] : wordsSaid[0]
    
    // see which choice has the most word matches
    for (var i = 0; i < choices.length; i++) {
        //console.log("choice ",i,choices[i])
        const oneChoiceWordList = choices[i].split(" ")

        // word counts for the choice
        var choiceDictionary = new Object()
        for (var j=0; j < oneChoiceWordList.length; j++) {
            const word = oneChoiceWordList[j]
            if (choiceDictionary[word] == undefined)
                choiceDictionary[word] = 1
            else
                choiceDictionary[word]++
        }
        var matchCount = 0;
        //console.log("choice words",i,choiceDictionary)
        Object.entries(choiceDictionary).forEach(entry => {
            const [key, value] = entry;
            if (wordDictionary[key] == undefined) 
                return
            const numberTimesSaid = wordDictionary[key]
            if (numberTimesSaid > value)
                matchCount += value
            else
                matchCount += numberTimesSaid
            //console.log("ENTRIES ",key, value);
          });
        //console.log("********* i  match",i,matchCount)
        
        //console.log("match count",matchCount)
        if (matchCount > bestMatchCount) {
            bestMatchCount = matchCount
            bestMatch = i
        }
    }
    return bestMatch
}

// handles the general case of matching a list
export function parseGeneralCommands(words,currentWordIndex,choiceList) {
    
    let currentWord = (words.length > currentWordIndex) ? words[currentWordIndex] : "xyz"
    let nextWord = (words.length > currentWordIndex+1) ? words[currentWordIndex+1] : "xyz"

    //console.log("in parse general  current",currentWord)
    if (currentWord == "ignore")
        return ["ignore",""];
    if (currentWord == "explain")
        return ["explain",""]
    if (currentWord == "done")
        return ["done",""]
    
    if (currentWord == "scroll") {
        if (nextWord == "up")
            return ["scroll", "up"]
        if (nextWord == "down")
            return ["scroll", "down"]
    }
    
    if (currentWord == "mute" || currentWord == "listen")
        return ([currentWord,""])
    
    // check against the choice list
    const bestIndex = findBestChoiceMatch(words, choiceList)
    if (bestIndex >= 0)
        return ["choice",bestIndex]
    return ["ignore",""];
}

export function parseGeneralWordsSaid(str, choiceList) {

    let words = str.split(" ")
    if (words.length == 0) {
        return ["ignore",""];
    }
    var currentWord = (words.length > 0) ? words[0] : "xyz"
    var nextWord = (words.length > 1) ? words[1] : "xyz"
    var nextNextWord = (words.length > 2) ? words[2] : "xyz"
        
    for (var i=0; i < words.length; i++) {
        //console.log("in parse general words said.  Current: ",currentWord)
        if (currentWord == "ignore")
            return ["ignore",""];

        if (currentWord == "command") {
            let returnArray = parseGeneralCommands(words, i+1, choiceList)
            return returnArray
        }
        currentWord = nextWord;
        nextWord = nextNextWord;
        nextNextWord = (i < words.length - 3) ? words[i + 3] : "xyz";
    }
    return ["ignore",""]
}

export function parseWordsSaid(str,parseCommandsCallBack) {
  
    const words = str.split(" ")

    //console.log("parse words said string ",str)
    //console.log("words",words,words.length)
    if (words.length == 0) {
        return ["ignore",""];
    }

    var currentWord = (words.length > 0) ? words[0] : "xyz"
    var nextWord = (words.length > 1) ? words[1] : "xyz"
    var nextNextWord = (words.length > 2) ? words[2] : "xyz"
          
    //console.log("current word",currentWord)

    for (var i = 0; i < words.length; i++) {
        if (currentWord == "ignore") {
            return ["ignore",""];
        }

        if (currentWord == "command") {
          const returnArray = parseCommandsCallBack(words, i+1)
          return returnArray
        }
        currentWord = nextWord;
        nextWord = nextNextWord;
        nextNextWord = (i < words.length - 3) ? words[i + 3] : "xyz";
    }
    return ["ignore",""]
}

export function parseNumberWords(currentWord,nextWord) {
    const numberStrings = [
                    "one","two","three","four","five","six","seven","eight","nine","ten","eleven",
                    "twelve","thirteen","fourteen","fifteen","sixteen","seventeen","eighteen","nineteen" ];
    var base = 0
    for (var i = 0; i < numberStrings.length; i++) {
        if (currentWord == numberStrings[i])
            return i+1
    }
    if (currentWord == "twenty")
        base = 20
    else
    if (currentWord == "thirty")
        base = 30
    else
    if (currentWord == "forty")
        base = 40
    else
    if (currentWord == "fifty")
        base = 50
    else
    if (currentWord == "sixty")
        base = 60
    else
    if (currentWord == "seventy")
        base = 70
    else
    if (currentWord == "eighty")
        base = 80
    else
    if (currentWord == "ninety")
        base = 90
    else
        return -1

    // did they say just the "tens" digit?
    if (nextWord == "xyz")
        return base

    for (var i = 0; i < 10; i++) {
        if (nextWord == numberStrings[i])
            return base + i + 1
    }
    return base
}